<template>
    <div class="cont-tit">
        <h2 class="page-title">Security</h2>
    </div>
    <div class="security">
        <section class="sec-wrap sec-wrap1">
            <h3 class="sec-tit">Overseas expansion strategic plan</h3>
            <p class="sec-desc">The OSE-B2C/B2B/O2O Commerce Ver.1.2 platform provides optimized functions for various fields such as B2C, B2B, and O2O service industries. <br>
                It is a flexible and scalable CLOUD Compute-based solution that promotes digital transformation <br>
                by supporting customized shopping experiences and efficient merchant and supply chain management.</p>

            <ul class="security__list sec-wrap__top">
                <li class="security__item">
                    <div class="security__icon">
                        <img src="../../assets/resource/img/security-img001.png" class="security-img1" alt="">
                        <img src="../../assets/resource/img/security-img002.png" class="security-img2" alt="">
                    </div>
                    <div class="security__box">
                        <div class="security__text">
                            <h4>Google Page Speed Insights <span>(Web/mobile application speed measurement)</span></h4>
                            <p>Evaluate performance by measuring page loading time, response time, throughput, and more.</p>
                        </div>
                        <div class="security__text">
                            <h4>Supply solution verification</h4>
                            <p>Verified over 20 projects (mobile loading time less than 3 seconds, desktop loading time less than 2 seconds)</p>
                        </div>
                    </div>
                </li>
                <li class="security__item">
                    <div class="security__icon">
                        <img src="../../assets/resource/img/security-img003.png" class="security-img3" alt="">
                    </div>
                    <div class="security__box">
                        <div class="security__text">
                            <h4>KISA (Korea Internet & Security Agency) ISMS certification and management ISMS certification verification</h4>
                            <p>We establish an information security management system and verify security compliance through Information Security Management System (ISMS) certification.</p>
                        </div>
                        <div class="security__text">
                            <h4>Supply solution verification</h4>
                            <p>After introduction by the customer, obtained and complied with ISMS certification and passed regular screening 5 times.</p>
                            <p>Acquired Korea Internet & Security Agency security certification ISMS (Information Security Management System)</p>
                            <ul>
                                <li>Security certification system for a comprehensive technical and physical management system based on the Information and Communications Network Act</li>
                                <li>Certification validity period: 18. 12. 27 ~ 23. 11. 3 / 6 years</li>
                            </ul>
                            <p>Client: OOO Co., Ltd.</p>
                        </div>
                    </div>
                </li>
                <li class="security__item">
                    <div class="security__icon">
                        <img src="../../assets/resource/img/security-img004.png" class="security-img4" alt="">
                        <img src="../../assets/resource/img/security-img005.png" class="security-img5" alt="">
                    </div>
                    <div class="security__box">
                        <div class="security__text">
                            <h4>OWASP ZAP, Burp Suite <span>(Verification of security vulnerabilities and security)</span></h4>
                            <p>Identify security vulnerabilities and verify security through penetration testing and traffic analysis.</p>
                        </div>
                        <div class="security__text">
                            <h4>Supply solution verification</h4>
                            <p>Removed OWASP Top 10 vulnerabilities more than 20 times and met mock hacking results standards</p>
                        </div>
                    </div>
                </li>
            </ul>
        </section>

        <!-- <section class="sec-wrap sec-wrap2">
            <h3 class="sec-tit">ISMS Self-Diagnosis AI Platform</h3>
            <div class="sec-wrap__top"><img src="@/assets/resource/img/security-img06.svg" alt=""></div>
        </section> -->
    </div>
</template>
<script>
    export default {

    }
</script>
<style>

</style>